// extracted by mini-css-extract-plugin
export default {"error":"charts_error__C6Q8x","tooltip":"charts_tooltip__BB-9+"};